<script>
  export default {
    name: 'ExpandLegacy',

    props: {
      open: Boolean,
      transitionName: {
        type: String,
        default: 'expand',
      },
    },

    mounted() {
      if (!this.open) {
        this.$refs.expand.style.overflow = 'hidden';
      }
    },

    methods: {
      /**
       * Expands the element
       * @param {object} element The element being expanded
       * @returns {void}
       */
      expand(element) {
        // Trick to calculate the height of the hidden element
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = element.offsetHeight;

        // Restore default styling
        element.style.visibility = '';
        element.style.display = '';

        // Set height on the element to zero
        element.style.height = 0;

        // Set expanded height after the other height change takes affect
        requestAnimationFrame(() => {
          element.style.height = `${height}px`;
        });
      },

      /**
       * Resores default styling after the expand animation is completed
       * @param {object} element - the element being expanded
       * @returns {void}
       */
      afterExpand(element) {
        element.style.height = '';
        element.style.overflow = '';
      },

      /**
       * Collapses the element
       * @param {object} element - the element being expanded
       * @returns {void}
       */
      collapse(element) {
        const height = element.offsetHeight;

        // Set height to the expanded height
        element.style.height = `${height}px`;
        element.style.overflow = 'hidden';

        // Set height to zero after the other height change takes affect
        requestAnimationFrame(() => {
          element.style.height = 0;
        });
      },
    },
  };
</script>

<template>
  <transition :name="transitionName" @after-enter="afterExpand" @enter="expand" @leave="collapse">
    <div v-show="open" ref="expand">
      <div class="relative ll-pt-5" :class="[$style['slot-wrapper'], { 'is-expanded': open }]">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<style module lang="scss">
  .slot-wrapper:global(.is-expanded) {
    &::before {
      animation: separator $secondary-transition 0.5s 1 forwards;
      background: var(--color-ice-200);
      content: '';
      height: map.get($borders, 'thin');
      left: calc(var(--grid-gutter) * -1);
      opacity: 0;
      position: absolute;
      right: calc(var(--grid-gutter) * -1);
      top: space(3);
    }
  }

  @keyframes separator {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
</style>
